<template>
  <v-container fluid class="px-0">
    <div class="dataContainer" @keydown.enter.prevent="searchData()">
      <v-row>
        <v-col cols="12" md="4">
          <el-text-field
            label="Ataskaitos numeris"
            tooltip="Archyvo naikinimas. Archyvaro aktas. Ataskaitos numeris"
            v-model="formData.nak_id"
          />
        </v-col>
        <v-col cols="12" md="4">
          <el-date-picker
            label="Ataskaitos suformavimo data nuo"
            tooltip="Archyvo naikinimas. Archyvaro aktas. Ataskaitos suformavimo data nuo"
            v-model="formData.nak_sukurimo_data_nuo"
          />
        </v-col>
        <v-col cols="12" md="4">
          <el-date-picker
            label="Ataskaitos suformavimo data iki"
            tooltip="Archyvo naikinimas. Archyvaro aktas. Ataskaitos suformavimo data iki"
            v-model="formData.nak_sukurimo_data_iki"
          />
        </v-col>
        <v-col cols="12" md="12">
          <el-text-field
            label="Ataskaitą suformavęs asmuo"
            tooltip="Archyvo naikinimas. Archyvaro aktas. Ataskaitą suformavęs asmuo"
            v-model="formData.suformavo"
          />
        </v-col>

        <v-col cols="12">
          <el-button
            primary
            :loading="loading"
            @click.native.stop="searchData()"
          >
            Ieškoti
          </el-button>
          <el-button :loading="loading" @click.native="clearData()">
            Išvalyti
          </el-button>
        </v-col>
      </v-row>
    </div>
  </v-container>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'NaikinimasArchyvarasSearch',
  props: {
    loading: Boolean,
  },
  data: () => ({
    formData: {},
    isSearching: false,
  }),
  computed: {
    ...mapGetters(['searchParams']),
  },
  inject: {
    $validator: '$validator',
  },
  created() {
    this.getData()
  },
  methods: {
    getData() {
      this.searchData()
    },
    searchData() {
      this.$validator.validateAll().then(res => {
        this.isSearching = true
        this.$emit('search', this.formData)
      })
    },
    clearData() {
      this.isSearching = false
      this.formData = {}
      //this.$emit('cancel')
    },
  },
}
</script>
<style lang="scss" scoped>
.dataContainer {
  max-width: 1100px;
}
</style>
